module.exports = __webpack_public_path__ + "static/media/jyp.8e993a3c.svg";